interface Preloader {
  displayLoadProgress: (progress: number) => void
  hide: () => void
}

/**
 * Creates a preloader controller bound to an element in DOM.
 * - Controls progress bar width
 * - Hides the preloader once assets are loaded
 */
export function createPreloader(): Preloader {
  const preloader = document.querySelector<HTMLDivElement>('.preloader')
  const preloaderBar = preloader?.querySelector<HTMLDivElement>('.preloader-bar')
  const enterButton = document.querySelector<HTMLButtonElement>('.enter-button')

  if (!preloader || !preloaderBar) {
    throw new Error('[preloader]: Required DOM elements not found')
  }

  // Reset state
  preloaderBar.style.width = '0'

  return {
    displayLoadProgress(progress: number) {
      preloaderBar.style.width = `${progress * 100}%`
    },
    hide() {
      preloader.style.display = 'none'
      enterButton?.classList.remove('hidden')
    },
  }
}
